import { useEffect } from 'react';

const SITE = 'there2b';
const DESCRIPTION_MAX = 160; // roughly what Google shows before cutting

const clip = (text) => {
  const flat = String(text || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (flat.length <= DESCRIPTION_MAX) return flat;
  return `${flat.slice(0, DESCRIPTION_MAX - 1).replace(/\s+\S*$/, '')}…`;
};

// Sets the tab title and meta description for a public page (event, brand)
// so each one can show up in Google as its own result. Google runs our JS
// before indexing; link-preview crawlers don't, so this doesn't change
// WhatsApp/Instagram previews. Restores the index.html values on leave so
// the next page doesn't inherit this one's.
export default function usePageMeta({ title, description } = {}) {
  useEffect(() => {
    if (!title) return undefined;
    const meta = document.querySelector('meta[name="description"]');
    const prevTitle = document.title;
    const prevDescription = meta?.getAttribute('content');

    document.title = `${title} | ${SITE}`;
    const text = clip(description);
    if (meta && text) meta.setAttribute('content', text);

    return () => {
      document.title = prevTitle;
      if (meta && prevDescription != null) {
        meta.setAttribute('content', prevDescription);
      }
    };
  }, [title, description]);
}
